<template>
  <v-card dark class="feature-card mb-6">
    <div class="video-placeholder">
      <v-icon x-large color="rgba(255,255,255,0.6)" class="pulsing-icon">mdi-play-circle-outline</v-icon>
    </div>

    <v-list-item class="pa-4">
      <v-list-item-avatar tile size="50" :color="color" class="mr-4 rounded-lg elevation-4">
        <v-icon> {{ icon }} </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="text-h6 font-weight-bold mb-1">{{ title }}</v-list-item-title>
        <v-list-item-subtitle class="body-1 wrap-text">{{ description }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  name: "FeatureCard",
  props: ["icon", "color", "title", "description"],
}
</script>

<style scoped>
.wrap-text {
  white-space: normal !important; /* Wichtigster Fix für den Textumbruch */
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.7) !important;
  padding-top: 4px;
}

.feature-card {
  background: rgba(40, 40, 40, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 24px !important;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.video-placeholder {
  height: 220px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent), url("https://www.transparenttextures.com/patterns/real-carbon-fibre.png");
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.pulsing-icon {
  animation: pulse 2.5s infinite cubic-bezier(0.4, 0, 0.6, 1);
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
}
</style>
